.dev-settings,
.dev-settings * {
  box-sizing: border-box;
}

.dev-settings {
  position: relative;
  padding: 10px;
  background: #020202a3;
  color: white;
  z-index: 0;
  grid-gap: 10px;
  display: grid;
  width: 270px;
  max-height: 500px;
  margin-left: auto;
  overflow-y: auto;
  

  &__wrapper {
    position: fixed;
    bottom: 0;
    right: 0;
    width: auto;
    transition: transform ease .25s;
    &.collapsed {
      transform: translateX(100%);
    }
  }


  .setting {
    display: flex;

    label,
    select {
      flex: 1;
    }
  }

  .separator {
    height: 1px;
    width: 100%;
    background: #fff;
  }
}

.dev-settings-collapse-btn {
  cursor: default;
  position: absolute;
  left: -22px;
  background: #020202a3;
  color: white;
  bottom: 2px;
  border-radius: 2px;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: left ease .25s;
}
